import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // Enforce light theme only
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.setAttribute('data-theme', 'light');
    try {
      localStorage.setItem('mindgarden-theme', 'light');
    } catch (e) {
      console.warn('Could not set theme in localStorage', e);
    }
  }, []);

  const value = {
    theme: 'light',
    toggleTheme: () => {}, // No-op: theme is locked to light
    setTheme: () => {}, // No-op: theme is locked to light
    isDark: false,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};